export type Rest = { [p: string]: any }

/**
 * Запрос на блок данных
 */
export interface SlicedRequest {
    /**
     * Количество возвращаемых в ответе записей; может принимать значение в диапазоне [1-1000].
     * Если параметр не задан, то количество записей по умолчанию равно 32
     */
    limit?: number | undefined
    /**
     * Порядковый номер, начиная с которого требуется вернуть данные.
     * Нумерация по умолчанию начинается с 0
     */
    offset?: number | undefined
}

/**
 * Данные по выборке
 */
export interface SlicedResponse {
    list_info: {
        /** Число возвращённых записей */
        records: number
        /** Общее число записей */
        total_count: number
    }
}

/**
 * Маппинг Boolean значений в числовые для использования в GridColDef[valueOptions] при создании фильтров
 */
export const NumericalBoolean = {
    FALSE: 0,
    TRUE: 1
}
